var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.48,417.26c86.39,41.17,226.46,41.17,312.85,0s86.39-107.93,0-149.11-226.46-41.17-312.85,0S11.09,376.08,97.48,417.26Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 269,
    cy: 379.89,
    rx: 25.66,
    ry: 12.23,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Boxes--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boxes--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "147.39 272.51 101.08 245.77 54.76 272.51 101.08 299.25 147.39 272.51",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.08 334.91 147.39 308.17 147.39 272.51 101.08 299.25 101.08 334.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,326.64a.48.48,0,0,1-.26-.07.62.62,0,0,1-.28-.57v-.65a.24.24,0,0,1,.24-.24.23.23,0,0,1,.23.24V326c0,.1,0,.15,0,.16s.07,0,.16,0a1.44,1.44,0,0,0,.44-1.08v-4.22a.23.23,0,0,1,.23-.23.23.23,0,0,1,.24.23V325a1.84,1.84,0,0,1-.67,1.49A.82.82,0,0,1,108,326.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.48,323v-.41a6.72,6.72,0,0,1,3-5.27,2,2,0,0,1,3.28,1.9v.13Zm4.46-5.63a2.34,2.34,0,0,0-1.18.37,6.23,6.23,0,0,0-2.78,4.42l5.34-3.08a1.77,1.77,0,0,0-.74-1.55A1.22,1.22,0,0,0,109.94,317.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.51,321.77a.23.23,0,0,1-.23-.23v-6.82a.24.24,0,1,1,.47,0v6.82A.23.23,0,0,1,116.51,321.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,316.56a.2.2,0,0,1-.1,0,.23.23,0,0,1-.12-.31l.85-2,.94,1.09a.24.24,0,0,1,0,.33.24.24,0,0,1-.34,0l-.45-.52-.54,1.26A.24.24,0,0,1,115.82,316.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.71,320.52a.24.24,0,0,1-.24-.24v-6.81a.24.24,0,0,1,.48,0v6.81A.24.24,0,0,1,118.71,320.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,315.31l-.1,0a.23.23,0,0,1-.12-.31l.84-2,1,1.08a.25.25,0,0,1,0,.34.25.25,0,0,1-.33,0l-.45-.52-.55,1.26A.22.22,0,0,1,118,315.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.08 334.91 54.76 308.17 54.76 272.51 101.08 299.25 101.08 334.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.17 320.53 79.66 322.55 79.66 286.89 76.17 284.87 76.17 320.53",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.56,290.65l-6.65,3.83a5,5,0,0,0-2.47,3.66c0,1.23,1.11,1.59,2.47.8l6.65-3.83a5,5,0,0,0,2.46-3.66C130,290.22,128.92,289.86,127.56,290.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.66 286.89 125.98 260.15 122.49 258.13 76.17 284.87 79.66 286.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.49 286.89 76.17 260.15 79.66 258.13 125.98 284.87 122.49 286.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "56.78 271.34 101.19 296.95 145.45 271.4 101.08 245.77 56.78 271.34",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "122.49 290.47 122.49 286.89 125.98 284.87 125.98 288.45 122.49 290.47",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.31 232.4 98.99 205.66 52.67 232.4 98.99 259.14 145.31 232.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "56.61 232.81 100.6 258.21 145.31 232.4 101.32 207 56.61 232.81",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "98.99 294.8 145.31 268.05 145.31 232.4 98.99 259.14 98.99 294.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,286.53a.59.59,0,0,1-.26-.07.62.62,0,0,1-.28-.57v-.65a.24.24,0,1,1,.47,0v.65c0,.1,0,.15,0,.16s.07,0,.15-.05a1.38,1.38,0,0,0,.44-1.07v-4.22a.24.24,0,0,1,.48,0v4.22a1.78,1.78,0,0,1-.68,1.48A.68.68,0,0,1,105.9,286.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.4,282.83v-.41a6.72,6.72,0,0,1,3-5.26,2,2,0,0,1,3.27,1.89v.14Zm4.46-5.63a2.51,2.51,0,0,0-1.19.37A6.27,6.27,0,0,0,103.9,282l5.34-3.08a1.76,1.76,0,0,0-.74-1.55A1.25,1.25,0,0,0,107.86,277.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.43,281.66a.24.24,0,0,1-.24-.24v-6.81a.24.24,0,1,1,.48,0v6.81A.24.24,0,0,1,114.43,281.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.74,276.45l-.1,0a.23.23,0,0,1-.12-.31l.84-1.95,1,1.08a.25.25,0,0,1,0,.34.25.25,0,0,1-.33,0l-.45-.52-.55,1.26A.23.23,0,0,1,113.74,276.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.63,280.41a.24.24,0,0,1-.24-.24v-6.82a.24.24,0,0,1,.48,0v6.82A.24.24,0,0,1,116.63,280.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.93,275.2l-.09,0a.25.25,0,0,1-.13-.32l.85-1.95.94,1.09a.24.24,0,0,1,0,.34.25.25,0,0,1-.34,0l-.44-.52-.55,1.26A.25.25,0,0,1,115.93,275.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.99 294.8 52.67 268.05 52.67 232.4 98.99 259.14 98.99 294.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.09 280.42 77.58 282.43 77.58 246.78 74.09 244.76 74.09 280.42",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.47,250.54l-6.64,3.83a5,5,0,0,0-2.47,3.66c0,1.23,1.11,1.59,2.47.8l6.64-3.84a4.91,4.91,0,0,0,2.47-3.65C127.94,250.11,126.84,249.75,125.47,250.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.58 246.78 123.9 220.04 120.41 218.02 74.09 244.76 77.58 246.78",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.41 246.78 74.09 220.04 77.58 218.02 123.9 244.76 120.41 246.78",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.41 250.36 120.41 246.78 123.9 244.76 123.9 248.34 120.41 250.36",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "100.6 258.21 104.77 260.62 145.31 237.21 145.31 232.4 100.6 258.21",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "149.95 196.74 103.64 170 57.32 196.74 103.64 223.48 149.95 196.74",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.64 259.14 149.95 232.4 149.95 196.74 103.64 223.48 103.64 259.14",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.54,250.87a.43.43,0,0,1-.25-.07.61.61,0,0,1-.29-.57v-.65a.24.24,0,0,1,.48,0v.65c0,.1,0,.15,0,.16s.07,0,.16,0a1.38,1.38,0,0,0,.44-1.07v-4.22a.24.24,0,1,1,.47,0v4.22a1.82,1.82,0,0,1-.67,1.48A.82.82,0,0,1,110.54,250.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,247.18v-.41a6.75,6.75,0,0,1,3-5.27,2,2,0,0,1,3.28,1.9v.13Zm4.46-5.63a2.34,2.34,0,0,0-1.18.37,6.26,6.26,0,0,0-2.78,4.42l5.34-3.08a1.79,1.79,0,0,0-.73-1.55A1.28,1.28,0,0,0,112.5,241.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.07,246a.23.23,0,0,1-.23-.24V239a.24.24,0,1,1,.47,0v6.82A.24.24,0,0,1,119.07,246Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.38,240.79a.15.15,0,0,1-.09,0,.23.23,0,0,1-.13-.31l.85-2,.94,1.09a.23.23,0,0,1,0,.33.24.24,0,0,1-.34,0l-.45-.52-.54,1.26A.24.24,0,0,1,118.38,240.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.27,244.75a.23.23,0,0,1-.24-.23V237.7a.24.24,0,0,1,.48,0v6.82A.23.23,0,0,1,121.27,244.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,239.54l-.1,0a.23.23,0,0,1-.12-.31l.84-2,1,1.08a.25.25,0,0,1,0,.34.23.23,0,0,1-.33,0l-.45-.52-.55,1.26A.22.22,0,0,1,120.58,239.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.64 259.14 57.32 232.4 57.32 196.74 103.64 223.48 103.64 259.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.73 244.76 82.22 246.78 82.22 211.12 78.73 209.1 78.73 244.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.12,214.88l-6.65,3.84a4.92,4.92,0,0,0-2.46,3.65c0,1.23,1.1,1.59,2.46.8l6.65-3.83a5,5,0,0,0,2.47-3.66C132.59,214.45,131.48,214.09,130.12,214.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.22 211.12 128.54 184.38 125.05 182.36 78.73 209.1 82.22 211.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.05 211.12 78.73 184.38 82.22 182.36 128.54 209.1 125.05 211.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.05 214.7 125.05 211.12 128.54 209.1 128.54 212.68 125.05 214.7",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Window--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plants--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.72,328.1V312.46a29.25,29.25,0,0,0-7-15.51c-6.18-6.69-11.72-4.42-13.52-1.24s2.3,9.2,4.92,12.6c3.15,4.08,15.58,23,15.58,31.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.72,325.63a.39.39,0,0,1-.38-.32c-2.82-17.05-15.8-28.75-15.93-28.87a.39.39,0,0,1,0-.54.38.38,0,0,1,.54,0c.14.11,13.31,12,16.18,29.31a.39.39,0,0,1-.32.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.72,328.1s.62-1.88-2.15-2.36-3.83-2.78-4.08-6.64-1.43-6.63-4.9-7.2-6.26,1.18-8.51-.56-8.08-5.93-12.94-4-3.26,6.06-.73,8.74,3.25,3.6,1.32,8-.53,8.46,3.94,9.48,7,.5,7,5.39.74,7.08,3.19,9,10.14,1.06,13.34,1.8a7,7,0,0,1,4.49,3.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.72,348.27a.38.38,0,0,1-.36-.26c-8.13-24.12-26.52-33.87-26.71-34a.39.39,0,0,1,.36-.69c.18.1,18.84,10,27.07,34.41a.37.37,0,0,1-.24.48A.25.25,0,0,1,168.72,348.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.06,327.24H157c-5.31-1.21-13.8-.55-13.89-.55a.38.38,0,0,1-.41-.35.37.37,0,0,1,.35-.41c.36,0,8.7-.67,14.12.57a.38.38,0,0,1-.09.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.39,338.84c-2.43,0-5-.16-5.16-.17a.39.39,0,0,1-.36-.41.38.38,0,0,1,.41-.36,59.12,59.12,0,0,0,8.3,0,.38.38,0,0,1,.43.32.38.38,0,0,1-.32.44A23.67,23.67,0,0,1,161.39,338.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.57,324.41h0a.39.39,0,0,1-.36-.41,29.09,29.09,0,0,1,1.71-8.08.38.38,0,0,1,.49-.21.37.37,0,0,1,.22.49,29.3,29.3,0,0,0-1.66,7.85A.38.38,0,0,1,154.57,324.41Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "window--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.6,173.36V355c0,1.66,1.16,2.33,2.6,1.5l218.22-126A5.74,5.74,0,0,0,392,226V44.38c0-1.66-1.16-2.33-2.59-1.5l-218.22,126A5.74,5.74,0,0,0,168.6,173.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.42,42.88l-218.22,126a5.74,5.74,0,0,0-2.6,4.5v11.36L392,55.45V44.38C392,42.72,390.85,42.05,389.42,42.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.55,63.05A5.63,5.63,0,0,0,359,67.48c0,1.63,1.14,2.29,2.56,1.48a5.69,5.69,0,0,0,2.56-4.44C364.11,62.89,363,62.23,361.55,63.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.7,57.18a5.67,5.67,0,0,0-2.56,4.43c0,1.64,1.15,2.3,2.56,1.48a5.63,5.63,0,0,0,2.56-4.43C374.26,57,373.12,56.37,371.7,57.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.86,51.32a5.67,5.67,0,0,0-2.56,4.43c0,1.63,1.15,2.3,2.56,1.48a5.67,5.67,0,0,0,2.56-4.43C384.42,51.16,383.27,50.5,381.86,51.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.69,168.58v54l-46.75,27v-54l46.75-27m1-1.73L190.94,195v56.29l48.75-28.15V166.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "images--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.44,214.62V157.18l49.74-28.72V185.9Zm1-56.86v55.13l47.74-27.57V130.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.6,156.81l2.62-5.66a12.76,12.76,0,0,0-8.36,1.7V158A9.24,9.24,0,0,1,286.6,156.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,160.64l4.24-4a8.37,8.37,0,0,0-5.17-5.22l-2.61,5.66A6,6,0,0,1,291,160.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,186.27l-2.61,5.65a12.58,12.58,0,0,0,8.35-1.68V185.1A9.08,9.08,0,0,1,274,186.27Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,177.73l2.61,2.64a38,38,0,0,0,5.17-11.19L291,170A27.28,27.28,0,0,1,287.5,177.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.86,184.46v5.14a30.77,30.77,0,0,0,8.35-8L286.6,179A22.24,22.24,0,0,1,280.86,184.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.62,157.63l-4.23,4a12.31,12.31,0,0,1,.41,3.24,18.5,18.5,0,0,1-.41,3.72l4.23-.85a25.7,25.7,0,0,0,.62-5.43A16.9,16.9,0,0,0,295.62,157.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.6,156.81l2.62-5.66a12.76,12.76,0,0,0-8.36,1.7V158A9.24,9.24,0,0,1,286.6,156.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291,160.64l4.24-4a8.37,8.37,0,0,0-5.17-5.22l-2.61,5.66A6,6,0,0,1,291,160.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M274,186.27l-2.61,5.65a12.58,12.58,0,0,0,8.35-1.68V185.1A9.08,9.08,0,0,1,274,186.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.5,177.73l2.61,2.64a38,38,0,0,0,5.17-11.19L291,170A27.28,27.28,0,0,1,287.5,177.73Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M280.86,184.46v5.14a30.77,30.77,0,0,0,8.35-8L286.6,179A22.24,22.24,0,0,1,280.86,184.46Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M295.62,157.63l-4.23,4a12.31,12.31,0,0,1,.41,3.24,18.5,18.5,0,0,1-.41,3.72l4.23-.85a25.7,25.7,0,0,0,.62-5.43A16.9,16.9,0,0,0,295.62,157.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.75,158.62v-5.14a30.62,30.62,0,0,0-8.35,8l2.61,2.64A22.06,22.06,0,0,1,279.75,158.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.12,165.35l-2.61-2.64a37.66,37.66,0,0,0-5.17,11.18l4.23-.85A27.06,27.06,0,0,1,273.12,165.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.81,178.17a18.61,18.61,0,0,1,.42-3.72l-4.23.86a25.69,25.69,0,0,0-.62,5.42,17,17,0,0,0,.62,4.72l4.23-4A12.37,12.37,0,0,1,268.81,178.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.57,182.44l-4.23,4a8.33,8.33,0,0,0,5.17,5.21l2.61-5.65A6,6,0,0,1,269.57,182.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,177c0-6.07,4.26-13.44,9.51-16.47s9.51-.58,9.51,5.49-4.26,13.44-9.51,16.47S270.8,183.09,270.8,177Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,177c0-6.07,4.26-13.44,9.51-16.47s9.51-.58,9.51,5.49-4.26,13.44-9.51,16.47S270.8,183.09,270.8,177Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.37,168.41a11.41,11.41,0,0,1,0,1.17,4.39,4.39,0,0,1-.16.95,3.48,3.48,0,0,1-.39.92,4.19,4.19,0,0,1-1.55,1.54,2.5,2.5,0,0,1-.91.35.94.94,0,0,1-.64-.1,1,1,0,0,1-.39-.47,2.31,2.31,0,0,1-.16-.76q0-.3,0-.57c0-.18,0-.38,0-.61a4.6,4.6,0,0,1,.16-1,4,4,0,0,1,.39-.91,4.21,4.21,0,0,1,.64-.85,4.27,4.27,0,0,1,.91-.69,2.67,2.67,0,0,1,.91-.36,1,1,0,0,1,.64.11,1,1,0,0,1,.39.47A2.6,2.6,0,0,1,279.37,168.41Zm3.34-3.75a1.69,1.69,0,0,1,.19-.33.89.89,0,0,1,.29-.24l1.1-.63a.24.24,0,0,1,.23-.05c.06,0,.09.08.09.17a.31.31,0,0,1,0,.08.56.56,0,0,1,0,.12L278,177.63a2,2,0,0,1-.2.32,1,1,0,0,1-.28.25l-1.1.63a.27.27,0,0,1-.23,0c-.06,0-.09-.08-.09-.17s0-.05,0-.09,0-.07,0-.11Zm-6,6.37a1,1,0,0,0,.14.53c.07.09.21.07.41,0a.92.92,0,0,0,.4-.43,2.08,2.08,0,0,0,.15-.69,8.68,8.68,0,0,0,0-1,.94.94,0,0,0-.15-.52c-.07-.09-.21-.08-.4,0a.89.89,0,0,0-.41.43,2.1,2.1,0,0,0-.14.69A5.68,5.68,0,0,0,276.72,171Zm8.85-.8a11.61,11.61,0,0,1,0,1.18,5.11,5.11,0,0,1-.15.94,4,4,0,0,1-1,1.76,4,4,0,0,1-.91.7,2.5,2.5,0,0,1-.91.35.89.89,0,0,1-.64-.1,1,1,0,0,1-.39-.47,2.31,2.31,0,0,1-.16-.76c0-.2,0-.39,0-.56s0-.39,0-.62a4.4,4.4,0,0,1,.16-.94,4.1,4.1,0,0,1,.39-.92,3.9,3.9,0,0,1,.64-.84,4,4,0,0,1,.91-.7,2.5,2.5,0,0,1,.91-.35.89.89,0,0,1,.64.1,1,1,0,0,1,.39.47A2.31,2.31,0,0,1,285.57,170.23Zm-2.65,2.63a1.05,1.05,0,0,0,.14.52c.08.09.21.08.41,0a.94.94,0,0,0,.41-.43,2.39,2.39,0,0,0,.14-.69,8.68,8.68,0,0,0,0-1,1.05,1.05,0,0,0-.14-.52c-.08-.09-.21-.08-.41,0a.94.94,0,0,0-.41.43,2.39,2.39,0,0,0-.14.69A5.79,5.79,0,0,0,282.92,172.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.43,177.1V119.65l49.74-28.72v57.45Zm1-56.87v55.13l47.74-27.56V92.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.75,121.09V116a30.62,30.62,0,0,0-8.36,8l2.62,2.65A22,22,0,0,1,344.75,121.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.11,127.83l-2.61-2.64a37.54,37.54,0,0,0-5.17,11.18l4.23-.86A27.41,27.41,0,0,1,338.11,127.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.59,119.29l2.62-5.67a12.76,12.76,0,0,0-8.36,1.7v5.13A9.11,9.11,0,0,1,351.59,119.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,123.11l4.23-4a8.35,8.35,0,0,0-5.17-5.21l-2.61,5.65A6,6,0,0,1,356,123.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,148.74l-2.61,5.66c2.4.49,5.27,0,8.36-1.69v-5.13A9.11,9.11,0,0,1,339,148.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.61,120.1l-4.23,4a12.37,12.37,0,0,1,.42,3.25,18.61,18.61,0,0,1-.42,3.72l4.23-.85a25.78,25.78,0,0,0,.62-5.43A17,17,0,0,0,360.61,120.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.49,140.2l2.61,2.64a37.66,37.66,0,0,0,5.17-11.18l-4.23.86A27.41,27.41,0,0,1,352.49,140.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.8,140.65a18.53,18.53,0,0,1,.42-3.72l-4.23.85a25.78,25.78,0,0,0-.62,5.43,16.9,16.9,0,0,0,.62,4.71l4.23-4A12.43,12.43,0,0,1,333.8,140.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.56,144.91l-4.23,4a8.35,8.35,0,0,0,5.17,5.21l2.61-5.65A6,6,0,0,1,334.56,144.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.85,146.94v5.13a30.62,30.62,0,0,0,8.36-7.95l-2.61-2.65A22.15,22.15,0,0,1,345.85,146.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M351.59,119.29l2.62-5.67a12.76,12.76,0,0,0-8.36,1.7v5.13A9.11,9.11,0,0,1,351.59,119.29Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M356,123.11l4.23-4a8.35,8.35,0,0,0-5.17-5.21l-2.61,5.65A6,6,0,0,1,356,123.11Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M339,148.74l-2.61,5.66c2.4.49,5.27,0,8.36-1.69v-5.13A9.11,9.11,0,0,1,339,148.74Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M360.61,120.1l-4.23,4a12.37,12.37,0,0,1,.42,3.25,18.61,18.61,0,0,1-.42,3.72l4.23-.85a25.78,25.78,0,0,0,.62-5.43A17,17,0,0,0,360.61,120.1Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M352.49,140.2l2.61,2.64a37.66,37.66,0,0,0,5.17-11.18l-4.23.86A27.41,27.41,0,0,1,352.49,140.2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M333.8,140.65a18.53,18.53,0,0,1,.42-3.72l-4.23.85a25.78,25.78,0,0,0-.62,5.43,16.9,16.9,0,0,0,.62,4.71l4.23-4A12.43,12.43,0,0,1,333.8,140.65Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M334.56,144.91l-4.23,4a8.35,8.35,0,0,0,5.17,5.21l2.61-5.65A6,6,0,0,1,334.56,144.91Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M345.85,146.94v5.13a30.62,30.62,0,0,0,8.36-7.95l-2.61-2.65A22.15,22.15,0,0,1,345.85,146.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M335.79,139.5c0-6.06,4.26-13.43,9.51-16.47s9.51-.57,9.51,5.49S350.55,142,345.3,145,335.79,145.57,335.79,139.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.79,139.5c0-6.06,4.26-13.43,9.51-16.47s9.51-.57,9.51,5.49S350.55,142,345.3,145,335.79,145.57,335.79,139.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.36,130.89a11.41,11.41,0,0,1,0,1.17,5.21,5.21,0,0,1-.15.95,4.23,4.23,0,0,1-.39.91,4.36,4.36,0,0,1-.65.85,4.27,4.27,0,0,1-.91.69,2.75,2.75,0,0,1-.91.36,1,1,0,0,1-.64-.1,1,1,0,0,1-.39-.47,2.38,2.38,0,0,1-.16-.77,5.4,5.4,0,0,1,0-.56c0-.18,0-.38,0-.61a4.49,4.49,0,0,1,.16-.95,4.3,4.3,0,0,1,.39-.92,3.9,3.9,0,0,1,.64-.84,4.27,4.27,0,0,1,.91-.69,2.75,2.75,0,0,1,.91-.36,1,1,0,0,1,.64.1,1,1,0,0,1,.39.47A2.38,2.38,0,0,1,344.36,130.89Zm3.34-3.75a2.41,2.41,0,0,1,.19-.33,1,1,0,0,1,.29-.24l1.1-.64a.31.31,0,0,1,.23-.05c.06,0,.09.08.09.18s0,0,0,.08a.61.61,0,0,1,0,.12l-6.6,13.84a2.41,2.41,0,0,1-.19.33.89.89,0,0,1-.29.24l-1.1.64a.3.3,0,0,1-.23.05c-.06,0-.09-.08-.09-.18a.31.31,0,0,1,0-.08.56.56,0,0,1,0-.12Zm-6,6.37a1,1,0,0,0,.14.52c.08.09.21.08.41,0a1,1,0,0,0,.41-.44,2.32,2.32,0,0,0,.14-.68,8.67,8.67,0,0,0,0-1,1,1,0,0,0-.14-.52c-.08-.09-.21-.08-.41,0a1,1,0,0,0-.41.44,2.32,2.32,0,0,0-.14.68A8.67,8.67,0,0,0,341.71,133.51Zm8.85-.8a7.62,7.62,0,0,1,0,1.17,5.08,5.08,0,0,1-.15,1,4.53,4.53,0,0,1-.39.92,4,4,0,0,1-.65.84,4.66,4.66,0,0,1-.91.7,2.62,2.62,0,0,1-.91.35.94.94,0,0,1-.64-.1,1,1,0,0,1-.39-.47,2.68,2.68,0,0,1-.16-.76c0-.2,0-.39,0-.57s0-.38,0-.61a5.24,5.24,0,0,1,.16-.95,4.3,4.3,0,0,1,.39-.92,4.45,4.45,0,0,1,.64-.84,4.54,4.54,0,0,1,.91-.69,2.75,2.75,0,0,1,.91-.36,1,1,0,0,1,.64.1,1,1,0,0,1,.39.47A2.44,2.44,0,0,1,350.56,132.71Zm-2.65,2.62a1,1,0,0,0,.14.52c.08.09.22.08.41,0a.91.91,0,0,0,.41-.44,2,2,0,0,0,.14-.68,5.79,5.79,0,0,0,0-1,.93.93,0,0,0-.14-.52c-.08-.09-.21-.08-.41,0a1,1,0,0,0-.41.44,2.39,2.39,0,0,0-.14.68A8.67,8.67,0,0,0,347.91,135.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.94 265.37 190.94 321.66 239.69 293.51 239.69 237.23 190.94 265.37",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.94 265.37 190.94 321.66 239.69 293.51 239.69 237.23 190.94 265.37",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.94,280.25c1.65.64,3.78.38,6.1-1,5.25-3,9.51-10.41,9.51-16.47a7.48,7.48,0,0,0-1.83-5.4l-13.78,7.95Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.41,281.64c.48-1.58,1.43-1.65,2.12-.14l6.88,15,10.25-38.81c.43-1.6,1.14-1.61,1.58,0l6.45,22.91v12.92l-37.47,21.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M190.94,280.25c1.65.64,3.78.38,6.1-1,5.25-3,9.51-10.41,9.51-16.47a7.48,7.48,0,0,0-1.83-5.4l-13.78,7.95Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.41,281.64c.48-1.58,1.43-1.65,2.12-.14l6.88,15,10.25-38.81c.43-1.6,1.14-1.61,1.58,0l6.45,22.91v12.92l-37.47,21.64Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M238.69,239v54l-46.75,27V266l46.75-27m1-1.73-48.75,28.14v56.29l48.75-28.15V237.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.69,239v54l-46.75,27V266l46.75-27m1-1.73-48.75,28.14v56.29l48.75-28.15V237.23Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.94 227.85 255.94 284.13 304.68 255.99 304.68 199.71 255.94 227.85",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.94 227.85 255.94 284.13 304.68 255.99 304.68 199.71 255.94 227.85",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.94,242.73c1.65.64,3.77.37,6.09-1,5.25-3,9.51-10.41,9.51-16.48a7.47,7.47,0,0,0-1.83-5.39l-13.77,7.95Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,244.12c.49-1.59,1.44-1.65,2.13-.15l6.87,15,10.26-38.81c.42-1.6,1.13-1.61,1.58,0l6.44,22.9V256l-37.47,21.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M255.94,242.73c1.65.64,3.77.37,6.09-1,5.25-3,9.51-10.41,9.51-16.48a7.47,7.47,0,0,0-1.83-5.39l-13.77,7.95Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M277.4,244.12c.49-1.59,1.44-1.65,2.13-.15l6.87,15,10.26-38.81c.42-1.6,1.13-1.61,1.58,0l6.44,22.9V256l-37.47,21.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M303.68,201.44v54l-46.74,27v-54l46.74-27m1-1.74-48.74,28.15v56.28L304.68,256V199.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.68,201.44v54l-46.74,27v-54l46.74-27m1-1.74-48.74,28.15v56.28L304.68,256V199.7Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.93 190.32 320.93 246.61 369.67 218.47 369.67 162.18 320.93 190.32",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.93 190.32 320.93 246.61 369.67 218.47 369.67 162.18 320.93 190.32",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.93,205.21c1.65.64,3.77.37,6.09-1,5.25-3,9.51-10.4,9.51-16.47a7.5,7.5,0,0,0-1.83-5.4l-13.77,7.95Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.39,206.59c.49-1.58,1.44-1.64,2.13-.14l6.87,15,10.26-38.82c.42-1.6,1.13-1.6,1.58,0l6.44,22.91v12.93L332.2,240.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M320.93,205.21c1.65.64,3.77.37,6.09-1,5.25-3,9.51-10.4,9.51-16.47a7.5,7.5,0,0,0-1.83-5.4l-13.77,7.95Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M342.39,206.59c.49-1.58,1.44-1.64,2.13-.14l6.87,15,10.26-38.82c.42-1.6,1.13-1.6,1.58,0l6.44,22.91v12.93L332.2,240.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M368.67,163.91v54l-46.74,27v-54l46.74-27m1-1.73-48.74,28.14v56.29l48.74-28.14V162.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.67,163.91v54l-46.74,27v-54l46.74-27m1-1.73-48.74,28.14v56.29l48.74-28.14V162.18Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "seleccion--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "363.58 181.44 377.94 185.27 373.1 188 381.88 194.43 380.74 196.19 371.7 189.72 370.5 195 363.58 181.44",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "speech-bubble--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coments--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.16,146.07l-31.36,18.1a5.74,5.74,0,0,0-2.6,4.5V194l-8,8.26c-1.15,1.19-.75,2,.89,1.8l7.07-.83v11.06c0,1.65,1.16,2.33,2.6,1.5l31.36-18.11a5.73,5.73,0,0,0,2.6-4.5V147.57C440.76,145.91,439.6,145.24,438.16,146.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.65,173.73l-1.32-.1c-1.74-.14-3.81-.83-3.81-3.32a5.86,5.86,0,0,1,2.64-4.58c1.14-.65,2.11-.38,2.48.56a5.91,5.91,0,0,1,2.48-3.42c1.46-.84,2.64-.16,2.64,1.53,0,2.44-2.06,5.53-3.79,7.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.11,159.45l7-4c1.43-.83,2.6-.45,2.6.85a5.22,5.22,0,0,1-2.6,3.84l-7,4c-1.44.83-2.6.45-2.6-.85A5.19,5.19,0,0,1,427.11,159.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,181.87l7-4c1.44-.83,2.6-.45,2.6.84a5.19,5.19,0,0,1-2.6,3.85l-7,4c-1.43.83-2.59.45-2.59-.84A5.21,5.21,0,0,1,412.11,181.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,191.65l22-12.69c1.43-.83,2.6-.45,2.6.84a5.22,5.22,0,0,1-2.6,3.85l-22,12.69c-1.43.83-2.59.45-2.59-.84A5.21,5.21,0,0,1,412.11,191.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,200.78l22-12.69c1.43-.83,2.6-.45,2.6.85a5.22,5.22,0,0,1-2.6,3.84l-22,12.69c-1.43.83-2.59.45-2.59-.84A5.21,5.21,0,0,1,412.11,200.78Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Picture--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "83.3 383.78 132.04 411.92 180.79 383.78 132.04 355.63 83.3 383.78",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.3 383.78 132.04 411.92 180.79 383.78 132.04 355.63 83.3 383.78",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,391.22a18.83,18.83,0,0,0,8.3-2.24c5.25-3,5.25-8,0-11a18.17,18.17,0,0,0-7.42-2.17L83.3,383.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.59,385.72c-.65-.94.72-1.24,3.06-.69L156,390.55l-18.23-22.37c-.75-.92.3-1.13,2.36-.46l29.51,9.6,11.19,6.46-37.47,21.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.19,391.22a18.83,18.83,0,0,0,8.3-2.24c5.25-3,5.25-8,0-11a18.17,18.17,0,0,0-7.42-2.17L83.3,383.78Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M129.59,385.72c-.65-.94.72-1.24,3.06-.69L156,390.55l-18.23-22.37c-.75-.92.3-1.13,2.36-.46l29.51,9.6,11.19,6.46-37.47,21.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M132,356.79l46.75,27-46.75,27-46.74-27,46.74-27m0-1.15L83.3,383.78,132,411.92l48.75-28.14L132,355.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,356.79l46.75,27-46.75,27-46.74-27,46.74-27m0-1.15L83.3,383.78,132,411.92l48.75-28.14L132,355.64Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.3 383.78 83.3 388.47 132.04 416.61 132.04 411.92 83.3 383.78",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.3 383.78 83.3 388.47 132.04 416.61 132.04 411.92 83.3 383.78",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.79 383.78 132.04 411.92 132.04 416.61 180.79 388.47 180.79 383.78",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.79 383.78 132.04 411.92 132.04 416.61 180.79 388.47 180.79 383.78",
    style: {
      fill: "#fafafa",
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Box--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "open-box--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "461.07 278.32 412.32 250.18 363.58 278.32 412.32 306.46 461.07 278.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.32 250.18 363.58 278.32 363.58 315.84 412.32 343.99 412.32 250.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.77 322.88 367.65 266.6 416.39 238.46 424.52 294.74 375.77 322.88",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.77 322.88 367.65 266.6 416.39 238.46 424.52 294.74 375.77 322.88",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.65 266.6 362.95 265.58 370.81 320.02 375.77 322.88 367.65 266.6",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.65 266.6 362.95 265.58 370.81 320.02 375.77 322.88 367.65 266.6",
    style: {
      fill: "#fafafa",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.7 237.44 416.39 238.46 367.65 266.6 362.95 265.58 411.7 237.44",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.7 237.44 416.39 238.46 367.65 266.6 362.95 265.58 411.7 237.44",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.19,266.18a8.19,8.19,0,0,0-4.21-5.54l-10.33,6,1.54,10.66a8.27,8.27,0,0,0,6.38.47A10,10,0,0,0,382.19,266.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.19,266.18a8.19,8.19,0,0,0-4.21-5.54l-10.33,6,1.54,10.66a8.27,8.27,0,0,0,6.38.47A10,10,0,0,0,382.19,266.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.22,268.53c.31-1.63,1.15-1.74,1.88-.25L402.28,283l5.48-31.51c.28-1.63,1.14-1.77,1.92-.31l11.71,21.89,3.13,21.65L383.9,318.19C383.82,317.75,391.11,279.55,393.22,268.53Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.22,268.53c.31-1.63,1.15-1.74,1.88-.25L402.28,283l5.48-31.51c.28-1.63,1.14-1.77,1.92-.31l11.71,21.89,3.13,21.65L383.9,318.19C383.82,317.75,391.11,279.55,393.22,268.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.61,240.06l7.82,54.15-46.88,27.07-7.82-54.15,46.88-27.07m.78-1.6L367.65,266.6l8.12,56.28,48.75-28.14-8.13-56.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.61,240.06l7.82,54.15-46.88,27.07-7.82-54.15,46.88-27.07m.78-1.6L367.65,266.6l8.12,56.28,48.75-28.14-8.13-56.28Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.02 332.26 383.89 275.98 432.64 247.84 440.76 304.12 392.02 332.26",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.02 332.26 383.89 275.98 432.64 247.84 440.76 304.12 392.02 332.26",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.89 275.98 379.2 274.96 387.06 329.4 392.02 332.26 383.89 275.98",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.89 275.98 379.2 274.96 387.06 329.4 392.02 332.26 383.89 275.98",
    style: {
      fill: "#fafafa",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.94 246.82 432.64 247.84 383.89 275.98 379.2 274.96 427.94 246.82",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.94 246.82 432.64 247.84 383.89 275.98 379.2 274.96 427.94 246.82",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.43,275.56a8.18,8.18,0,0,0-4.21-5.55l-10.33,6,1.54,10.66a8.27,8.27,0,0,0,6.38.47A10,10,0,0,0,398.43,275.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.43,275.56a8.18,8.18,0,0,0-4.21-5.55l-10.33,6,1.54,10.66a8.27,8.27,0,0,0,6.38.47A10,10,0,0,0,398.43,275.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.47,277.91c.31-1.63,1.15-1.74,1.88-.25l7.18,14.73,5.47-31.5c.28-1.64,1.15-1.77,1.93-.31l11.71,21.89,3.12,21.65-40.62,23.45C400.06,327.13,407.36,288.93,409.47,277.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.47,277.91c.31-1.63,1.15-1.74,1.88-.25l7.18,14.73,5.47-31.5c.28-1.64,1.15-1.77,1.93-.31l11.71,21.89,3.12,21.65-40.62,23.45C400.06,327.13,407.36,288.93,409.47,277.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.86,249.44l7.82,54.15L392.8,330.66,385,276.51l46.88-27.07m.78-1.6L383.89,276,392,332.26l48.74-28.14-8.12-56.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.86,249.44l7.82,54.15L392.8,330.66,385,276.51l46.88-27.07m.78-1.6L383.89,276,392,332.26l48.74-28.14-8.12-56.28Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.32 343.99 461.07 315.85 461.07 278.32 412.32 306.46 412.32 343.99",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.33,306.46l-48.75-28.14v37.52L412.33,344Zm-20.88-2.67-7-4a5.19,5.19,0,0,1-2.6-3.85c0-1.3,1.16-1.67,2.6-.85l7,4a5.22,5.22,0,0,1,2.6,3.85C394.05,304.24,392.88,304.62,391.45,303.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.65,
    y: 290.76,
    width: 56.29,
    height: 24.37,
    transform: "translate(-92.15 261.98) rotate(-30)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.58 287.7 359.52 290.05 363.58 278.32 363.58 287.7",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.31,104.08l-3.14,1.21V98.36c0-5.49-4.39-6.81-9.15-4.06h0c-4.76,2.74-8.61,9.43-8.61,14.92v1a4.62,4.62,0,0,0-4,.62h0a13.68,13.68,0,0,0-6.21,10.74v.46l-4.38,2.53a9,9,0,0,0-4.09,7.07c0,2.61,1.83,3.66,4.09,2.36l35.49-20.49a9,9,0,0,0,4.09-7.08C193.4,103.84,191.57,102.78,189.31,104.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Girl--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.18,371.93l-.18-6.05,5-.86.29,5.16c.24,1.2,1.09,1.59,1.31,2.27s-3.42,7.6-5.46,9.13-5.36-.43-5.68-1.16,2.73-.19,3.23-1.25C258.37,377.75,259.18,371.93,259.18,371.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.74,371.18c-.66.55-1.16,1.94-2.07,3.84s-2.2,5-3.61,5.41c-1.64.52-4.86-.42-2.81-.58.45,0,1.24-.2,1.45-.68a2.75,2.75,0,0,0,.19-.52,6.35,6.35,0,0,1-2.18.2,2.93,2.93,0,0,0-2.86,1.23c-.34.51.21,1.37.21,1.37.63.77,1.8,1.54,4.5,1.74s4.3-.19,5.27-2a59.9,59.9,0,0,1,4.1-5.83C267.94,373.81,266.31,371.59,264.74,371.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.86,378.76c-.16.41-1.35.54-1.94.62s-.88.63.08.94C257.66,380.49,258.48,378.73,257.86,378.76Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.59,352.37,302.43,348l3.18-4,3.64,3.67c1,.74,1.88.47,2.49.83s2.49,8,2,10.46-4.29,3.23-5,2.89,1.92-1.95,1.59-3.07C309.84,357.26,306.59,352.37,306.59,352.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.25,348.12c-.13.85.41,2.22,1,4.24s1.66,5.19.89,6.45c-.88,1.47-3.91,2.91-2.48,1.43.31-.33.79-1,.63-1.47a3,3,0,0,0-.2-.52,6.48,6.48,0,0,1-1.51,1.6,2.88,2.88,0,0,0-1.31,2.81c.08.61,1.06.89,1.06.89,1,.16,2.37-.05,4.52-1.68s3.09-3,2.6-5a62.17,62.17,0,0,1-.81-7.08C314.39,348,311.69,347.38,310.25,348.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.13,358.35c.15.42-.66,1.3-1.05,1.76s-.24,1.05.69.64C311.13,359.78,310.57,357.92,310.13,358.35Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.89,259.72c1.33-4.62.49-7.43-.53-11.43-1.88-7.32-3.66-14.67-3.66-14.67s-1.33-27.88-1.39-30.42c-.07-3-.65-4.68-.9-7.22-.14-1.44-1.17-1.59-1.07-1.54v5.64a30.74,30.74,0,0,1-2.61-2.63c-.94-1.13-1.89-1-2.19-.43s1.25,1.68,2,3.15a39.48,39.48,0,0,0,2.81,4.23v15.24l-4,2.32-.78,14.56,6.22,22.65Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.74 250.15 255.6 257.73 263.07 258.59 261.99 248.53 254.74 250.15",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.59 191.5 216.59 247.78 265.34 219.64 265.34 163.35 216.59 191.5",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.59 191.5 216.59 247.78 265.34 219.64 265.34 163.35 216.59 191.5",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.59,206.38c1.65.64,3.78.37,6.1-1,5.25-3,9.51-10.41,9.51-16.48a7.52,7.52,0,0,0-1.83-5.4l-13.78,8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.59,206.38c1.65.64,3.78.37,6.1-1,5.25-3,9.51-10.41,9.51-16.48a7.52,7.52,0,0,0-1.83-5.4l-13.78,8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.06,207.77c.48-1.59,1.43-1.65,2.12-.15l6.88,15,10.26-38.81c.42-1.6,1.13-1.61,1.57,0l6.45,22.91v12.93l-37.47,21.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.06,207.77c.48-1.59,1.43-1.65,2.12-.15l6.88,15,10.26-38.81c.42-1.6,1.13-1.61,1.57,0l6.45,22.91v12.93l-37.47,21.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.34,165.09v54l-46.75,27v-54l46.75-27m1-1.74L216.59,191.5v56.28l48.75-28.14V163.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.34,165.09v54l-46.75,27v-54l46.75-27m1-1.74L216.59,191.5v56.28l48.75-28.14V163.35Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.59 247.78 212.53 245.44 212.53 189.15 216.59 191.5 216.59 247.78",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.59 247.78 212.53 245.44 212.53 189.15 216.59 191.5 216.59 247.78",
    style: {
      fill: "#fafafa",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.53 189.15 261.27 161.01 265.34 163.35 216.59 191.5 212.53 189.15",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.53 189.15 261.27 161.01 265.34 163.35 216.59 191.5 212.53 189.15",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.89,259.72c-.13.65-.43,1.93-1,4.09-1.1,4-2.76,9.67-3.47,11.56,0,.08-.06.15-.09.21l2.95,4.8s-2,2.45-7.86,4.16-13-1.76-13-1.76-1.51-7.92-1.79-10.14c0-.13,0-.33-.08-.56-.06-.47-.12-.89-.21-1.28,0,0,0-.07,0-.11-.11-.48-.19-1.12-.33-1.83A7.83,7.83,0,0,0,244,263c-.83-.45-18.06-7.27-20.78-8.93a5.33,5.33,0,0,1-2.76-3.59c-.38-1.05-5.62-18.35-6.24-20.07a9,9,0,0,0-2.56-3.71c-1.36-1.46-1.84-1.79-2.26-3.1s.11-1.63.32-2.28c.29-.9,0-1.53.16-2.21.25-.85.77-1.07.9-1.45a13.07,13.07,0,0,1,.35-2,2.89,2.89,0,0,1,1.38-1.45v2c.75,3.07,4.12,4.58,4.55,4.36s1.06-2,2-2.74,2.24-.67,1.76.26c-.27.54-.89,2.55-1.21,3.44s-1.27,2.76-1.06,4.19c.27,1.91,9.15,21.6,9.15,21.6s9.65,3.16,17.31,5.54c4.75,1.48,8.66,2.39,8.66,2.39l2.37-.42.89-.16,11.54-2.12.42-.08a4.37,4.37,0,0,1,1.14,0,3.94,3.94,0,0,1,2.44,2.08A7.57,7.57,0,0,1,272.89,259.72Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.17,286.81s14.52,35.46,15.84,38.7a10.71,10.71,0,0,0,4.63,5.65c1.94,1.35,27.23,18.76,27.23,18.76,3.87-1.61,3.95-4.13,3.95-4.13S294.76,329.14,292,326.74s-7.87-3.62-7.87-3.62l-6.43-27c-.86-4.14-.33-8.72-6.49-15.77h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.71,284.83c3,4.16,5.75,7.82,6.53,12.61,1.64,10.13-2.33,22.49-2.81,30.05a17,17,0,0,1,2.56,7.56c.14,3.11-2.6,31.74-2.6,31.74a8.81,8.81,0,0,1-5.56,1s-6.1-41.37-7.27-54.82-1.2-30.15-1.2-30.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92,238.88a6.73,6.73,0,0,1,1-6.42c2.85-3.85,8.27-5.49,14-3.5,2.85,1,6.33,4.24,6.24,11.27-.06,4.31-12.24,6.63-12.18,9.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.55,240.49s-1.81,2.49-1.6,2.78a4,4,0,0,0,1.27.61Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.1,232.58c-1.69.78-4.61,2.23-5.62,8.28-1,6.22,0,8.26.79,9.12.55.58,3.65.72,5.21.31,2-.52,6.4-2,8.51-5.17,2.48-3.69,3.18-8.72.6-10.82A10,10,0,0,0,255.1,232.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36,282.79l20.89-2.41c1.47,2.41,5,6.53,4.25,10.49-.91,4.79-3.49,8.16-11.38,10.51",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,266.88c-1.06,3.93-1.93,6.7-2.6,8.49,0,.08-.06.15-.09.21l2.95,4.8s-2,2.45-7.86,4.16-13-1.76-13-1.76-1.51-7.92-1.79-10.14c0-.13,0-.33-.08-.56s-.13-.82-.21-1.28c0,0,0-.07,0-.11-.13-.79-.27-1.56-.33-1.83,7.53-3.36,5.76-13.64,5.76-13.64l2.37-.42.89-.16c3.45-.61,5.91-1.07,9-1.68C266.13,252.93,272.72,260.48,271,266.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,273.55a47.84,47.84,0,0,1-7.55,3.93,14.38,14.38,0,0,0,6.85-1.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.6,232.82s-1.69,5.63-.13,9.31c0,0,1.11-2.18,3-1.45s1.61,3.28,0,4.52a2.85,2.85,0,0,1-3,.5,8.55,8.55,0,0,0,1.9,5,11.1,11.1,0,0,0,11.5-2.73c4.83-4.73,4.63-13.6-2.08-16.17S254.6,232.82,254.6,232.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.75,312.66l1.71-13.75s5-1.9,7.15-4.84a12.89,12.89,0,0,1-5,6.22c-.34.43-3,14.53-3,14.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,238.47c-2.32,1-4.07-.84-5.34-3.78s-1.55-5.88.76-6.88,5.1.88,6.36,3.82S276.64,237.47,274.33,238.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.34,200.08a5.27,5.27,0,0,1-1.72-1.6c-.7-1-1.7-1.48-2.3-1.14-.44.24.08,1,.41,1.63a12.56,12.56,0,0,0,2,3.37c.93.86,1.6,1.07,1.6,2.06a3,3,0,0,0,.75-2.1A3.83,3.83,0,0,0,265.34,200.08Z",
    style: {
      fill: "#ffa8a7"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIllustration);
export default __webpack_public_path__ + "static/media/about-illustration.31eb9a055ae6c8142d3785886bfbbef8.svg";
export { ForwardRef as ReactComponent };